/* wsapi3-login-sidebar v1.0 */
/* Deploy Version 2026-09-29 13:51:01 */
/* Deploy Version 2026-09-24 19:11:11 */
/* Deploy Version 2026-08-10 */
wsMain.createModule({
  name: 'login-sidebar',
  version: '1.0',
  updatedAt: '2026-08-10',
  function: 'get',

  _flow: null,

  async get() {
    const mod = wsMain.modules['login-sidebar'];
    mod._moveToBody();
    mod._bindOnce();
    mod._bindGlobalLoginLinks();
    return true;
  },

  // Qualquer <a href="/login"> do site (menu mobile, botão de "Fazer Login"
  // na página de produto indisponível, links avulsos em conteúdo, etc.) abre
  // a sidebar em vez de navegar pra a página cheia — sem precisar cadastrar
  // esse comportamento em cada lugar que hoje tem um link assim (só o botão
  // de usuário no header fazia isso, ver wsapi3-login-options.js). Delegado
  // no document pra pegar também links inseridos depois do load inicial.
  // Só existe efeito em temas que carregam este módulo — em quem não carrega,
  // esses mesmos links continuam navegando normalmente pra /login.
  _bindGlobalLoginLinks() {
    if (document.documentElement.dataset.loginSidebarLinksBound) return;
    document.documentElement.dataset.loginSidebarLinksBound = '1';

    document.addEventListener('click', (e) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      const link = e.target.closest('a[href="/login"]');
      if (!link || link.target === '_blank') return;
      if (ApiWS.User.isValid()) return; // já logado — deixa navegar (a própria /login redireciona)

      e.preventDefault();
      wsMain.modules['login-sidebar'].open();
    });
  },

  // O placeholder do módulo é injetado dentro de <header> — como o holder é
  // position:fixed, ele fica preso ao stacking context do header (mesmo
  // problema documentado em wsapi3-cart-drawer-rules.js/_moveDrawerToBody).
  // Movendo pro <body>, o z-index passa a valer de verdade.
  _moveToBody() {
    const holder = document.querySelector('[data-wsjs-login-sidebar="holder"]');
    const overlay = document.querySelector('[data-wsjs-login-sidebar="overlay"]');
    if (holder && holder.parentElement !== document.body) document.body.appendChild(holder);
    if (overlay && overlay.parentElement !== document.body) document.body.appendChild(overlay);
  },

  _el(name) {
    return document.querySelector(`[data-wsjs-login-sidebar="${name}"]`);
  },

  // A lógica de identificação/senha/social/esqueci-senha em si vem de
  // wsapi3-identify-flow (compartilhada com wsapi3-login-page e a tela de
  // identificação de wsapi3-checkout-payment-page) — aqui só ficam os
  // seletores próprios da sidebar e o que muda em cada uma (ver comentário
  // de config no topo de wsapi3-identify-flow.js).
  _bindOnce() {
    const mod = wsMain.modules['login-sidebar'];
    const holder = mod._el('holder');
    if (!holder || holder.dataset.bound) return;
    holder.dataset.bound = '1';

    mod._el('close')?.addEventListener('click', () => mod.close());
    mod._el('overlay')?.addEventListener('click', () => mod.close());

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && holder.classList.contains('active')) mod.close();
    });

    mod._flow = WsIdentifyFlow.create({
      els: {
        identityRow: '[data-wsjs-login-sidebar="identity-row"]',
        identityInput: '[data-wsjs-login-sidebar="identity-input"]',
        displayRow: '[data-wsjs-login-sidebar="identity-display-row"]',
        displayValue: '[data-wsjs-login-sidebar="identity-display-value"]',
        changeIdentityLink: '[data-wsjs-login-sidebar="change-identity-link"]',
        passwordField: '[data-wsjs-login-sidebar="password-field"]',
        passwordInput: '[data-wsjs-login-sidebar="password-input"]',
        continueBtn: '[data-wsjs-login-sidebar="continue-btn"]',
        continueLabel: '[data-wsjs-login-sidebar="continue-label"]',
        mainMsg: '[data-wsjs-login-sidebar="main-msg"]',
        title: '[data-wsjs-login-sidebar="main-title"]',
        googleBtn: '[data-wsjs-login-sidebar="google-btn"]',
        facebookBtn: '[data-wsjs-login-sidebar="facebook-btn"]',
        forgotLink: '[data-wsjs-login-sidebar="forgot-link"]',
        screenMain: '[data-wsjs-login-sidebar="screen-main"]',
        screenForgot: '[data-wsjs-login-sidebar="screen-forgot"]',
        forgotEmail: '[data-wsjs-login-sidebar="forgot-email"]',
        forgotMsg: '[data-wsjs-login-sidebar="forgot-msg"]',
        forgotSendBtn: '[data-wsjs-login-sidebar="forgot-send-btn"]',
        forgotBackBtn: '[data-wsjs-login-sidebar="forgot-back-btn"]',
        screenVerify: '[data-wsjs-login-sidebar="screen-verify"]',
        verifyEmailLabel: '[data-wsjs-login-sidebar="verify-email-label"]',
        verifyCode: '[data-wsjs-login-sidebar="verify-code"]',
        verifyMsg: '[data-wsjs-login-sidebar="verify-msg"]',
        verifyBtn: '[data-wsjs-login-sidebar="verify-btn"]',
        verifyBackBtn: '[data-wsjs-login-sidebar="verify-back-btn"]',
        screenReset: '[data-wsjs-login-sidebar="screen-reset"]',
        resetPassword: '[data-wsjs-login-sidebar="reset-password"]',
        resetPasswordConfirm: '[data-wsjs-login-sidebar="reset-password-confirm"]',
        resetMsg: '[data-wsjs-login-sidebar="reset-msg"]',
        resetBtn: '[data-wsjs-login-sidebar="reset-btn"]',
      },
      // Empilhado (campo, senha, botão) — o botão não precisa se mover entre
      // linhas como no login-page/checkout, só o rótulo muda.
      moveButton: false,
      socialSignupFallback: true,

      // Em vez de mandar pra /cadastro, completa o cadastro na própria sidebar
      // (screen-signup, fora do WsIdentifyFlow — mesmo padrão do acordeão de
      // wsapi3-checkout-payment-page). Ver _showSignupScreen.
      onIdentityNew(identity) {
        mod._showSignupScreen(identity);
      },
      // A sidebar abre por cima de qualquer página do site — o usuário deve
      // continuar exatamente onde estava, só que já autenticado, em vez de
      // ser redirecionado como nas outras duas telas.
      onLoginSuccess() {
        window.location.reload();
      },
      onSocialSignupResolved(provider, data) {
        // O popup pode terminar depois de a sidebar ter sido fechada. Reabre e
        // usa o mesmo cadastro inline do fluxo de identificação por e-mail.
        mod.open();
        mod._showSignupScreen({ type: 'email', value: data.email });
      },
    });

    mod._flow.init();
    mod._bindSignupScreen();
  },

  open() {
    const mod = wsMain.modules['login-sidebar'];
    const holder = mod._el('holder');
    if (!holder) return;
    if (ApiWS.User.isValid()) return; // já logado — quem trata isso é o dropdown normal

    if (mod._flow) mod._flow.reset();
    const signupScreen = mod._el('screen-signup');
    if (signupScreen) signupScreen.style.display = 'none';
    mod._el('scroll')?.classList.remove('wslg-scroll--top');
    const headerTitle = mod._el('header-title');
    if (headerTitle) headerTitle.textContent = 'Identifique-se';

    holder.classList.add('active');
    document.body.style.overflow = 'hidden';
    mod._el('overlay')?.setAttribute('style', 'width:100%;height:100%;opacity:0.8');
  },

  close() {
    const mod = wsMain.modules['login-sidebar'];
    const holder = mod._el('holder');
    if (!holder) return;
    holder.classList.remove('active');
    document.body.style.overflow = '';
    mod._el('overlay')?.setAttribute('style', 'width:0;height:0;opacity:0');
  },

  /* ─────────────────────────────────────────────
     CADASTRO INLINE (screen-signup)

     Mesmo contrato de campos do POST /auth/signup usado por wsapi3-signup-page
     e pelo "cliente novo" de wsapi3-checkout-payment-page, só que numa tela
     única — sem os 2 passos, o medidor de força de senha e a validação de
     e-mail/CPF no blur da página cheia (aqui o objetivo é fechar o cadastro
     sem sair da sidebar; a API já valida tudo de novo no submit).
  ───────────────────────────────────────────── */

  _onlyDigits(v) { return String(v || '').replace(/\D/g, ''); },

  _bindMask(input, fmt) {
    const mod = wsMain.modules['login-sidebar'];
    if (!input) return;
    input.addEventListener('input', () => { input.value = fmt.call(mod, input.value); });
  },

  _fmtCpf(v) {
    const d = this._onlyDigits(v).substring(0, 11);
    if (d.length <= 3) return d;
    if (d.length <= 6) return d.substring(0, 3) + '.' + d.substring(3);
    if (d.length <= 9) return d.substring(0, 3) + '.' + d.substring(3, 6) + '.' + d.substring(6);
    return d.substring(0, 3) + '.' + d.substring(3, 6) + '.' + d.substring(6, 9) + '-' + d.substring(9);
  },

  _fmtCnpj(v) {
    const d = this._onlyDigits(v).substring(0, 14);
    if (d.length <= 2) return d;
    if (d.length <= 5) return d.substring(0, 2) + '.' + d.substring(2);
    if (d.length <= 8) return d.substring(0, 2) + '.' + d.substring(2, 5) + '.' + d.substring(5);
    if (d.length <= 12) return d.substring(0, 2) + '.' + d.substring(2, 5) + '.' + d.substring(5, 8) + '/' + d.substring(8);
    return d.substring(0, 2) + '.' + d.substring(2, 5) + '.' + d.substring(5, 8) + '/' + d.substring(8, 12) + '-' + d.substring(12);
  },

  _fmtBirth(v) {
    const d = this._onlyDigits(v).substring(0, 8);
    if (d.length <= 2) return d;
    if (d.length <= 4) return d.substring(0, 2) + '/' + d.substring(2);
    return d.substring(0, 2) + '/' + d.substring(2, 4) + '/' + d.substring(4);
  },

  _fmtMobile(v) {
    const d = this._onlyDigits(v).substring(0, 11);
    if (!d.length) return '';
    if (d.length <= 2) return '(' + d;
    if (d.length <= 7) return '(' + d.substring(0, 2) + ') ' + d.substring(2);
    return '(' + d.substring(0, 2) + ') ' + d.substring(2, 7) + '-' + d.substring(7);
  },

  _fmtCep(v) {
    const d = this._onlyDigits(v).substring(0, 8);
    return d.length > 5 ? d.substring(0, 5) + '-' + d.substring(5) : d;
  },

  // 'DD/MM/AAAA' -> 'AAAA-MM-DD' (formato aceito por birth_date na API); string
  // vazia se incompleto/mal formado (campo é opcional, não bloqueia o submit).
  _parseBirthDate(v) {
    const parts = (v || '').split('/');
    return parts.length === 3 && parts[2].length === 4 ? parts[2] + '-' + parts[1] + '-' + parts[0] : '';
  },

  // Fallback pra browsers sem :has() (ver .wslg-select--placeholder no CSS) —
  // chamado no bind, em toda troca manual do <select> e sempre que o value é
  // setado via JS (ViaCEP, reset), já que isso não dispara 'change' sozinho.
  _updateSelectPlaceholderStyle(select) {
    if (!select) return;
    select.classList.toggle('wslg-select--placeholder', select.value === '');
  },

  _bindSignupScreen() {
    const mod = wsMain.modules['login-sidebar'];
    const holder = mod._el('screen-signup');
    if (!holder || holder.dataset.signupBound) return;
    holder.dataset.signupBound = '1';

    const typeF = mod._el('signup-type-f');
    const typeJ = mod._el('signup-type-j');
    const cpfField = mod._el('signup-cpf-field');
    const cnpjField = mod._el('signup-cnpj-field');
    const razaoField = mod._el('signup-razao-field');
    const typeWrap = mod._el('signup-person-type');

    function updatePersonType() {
      const isF = !!(typeF && typeF.checked);
      if (cpfField) cpfField.style.display = isF ? '' : 'none';
      if (cnpjField) cnpjField.style.display = isF ? 'none' : '';
      if (razaoField) razaoField.style.display = isF ? 'none' : '';
      // Fallback pra browsers sem :has() — ver .wslg-person-type-option.selected.
      typeWrap?.querySelectorAll('.wslg-person-type-option').forEach((opt) => {
        const radio = opt.querySelector('input[type="radio"]');
        if (radio) opt.classList.toggle('selected', radio.checked);
      });
    }
    typeF?.addEventListener('change', updatePersonType);
    typeJ?.addEventListener('change', updatePersonType);
    updatePersonType();

    mod._bindMask(mod._el('signup-cpf'), mod._fmtCpf);
    mod._bindMask(mod._el('signup-cnpj'), mod._fmtCnpj);
    mod._bindMask(mod._el('signup-birth'), mod._fmtBirth);
    mod._bindMask(mod._el('signup-mobile'), mod._fmtMobile);

    const cepInput = mod._el('signup-cep');
    mod._bindMask(cepInput, mod._fmtCep);
    if (cepInput) {
      // Dispara assim que o 8º dígito é digitado (ou colado), sem esperar
      // sair do campo — a máscara já rodou antes (registrada acima), então o
      // value aqui já está formatado.
      cepInput.addEventListener('input', () => {
        if (mod._onlyDigits(cepInput.value).length === 8) mod._lookupSignupCep();
      });
      cepInput.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') { e.preventDefault(); mod._lookupSignupCep(); }
      });
    }

    WsIdentifyFlow.bindPasswordToggle(mod._el('signup-password'));
    WsIdentifyFlow.bindPasswordToggle(mod._el('signup-password-confirm'));

    [mod._el('signup-gender'), mod._el('signup-state')].forEach((select) => {
      if (!select) return;
      select.addEventListener('change', () => mod._updateSelectPlaceholderStyle(select));
      mod._updateSelectPlaceholderStyle(select);
    });

    mod._el('signup-submit-btn')?.addEventListener('click', () => mod._submitSignup());
  },

  // Preenche rua/bairro/cidade/UF via ViaCEP (mesma fonte usada por
  // wsapi3-signup-page e wsapi3-checkout-payment-page) quando o CEP tem 8 dígitos.
  // Os campos de endereço só existem na tela a partir daqui — ficam ocultos
  // até o CEP estar completo (ver HTML/_resetSignupForm).
  async _lookupSignupCep() {
    const mod = wsMain.modules['login-sidebar'];
    const cepInput = mod._el('signup-cep');
    const cep = mod._onlyDigits((cepInput || {}).value || '');
    if (cep.length !== 8) return;

    const addressFields = mod._el('signup-address-fields');
    if (addressFields) addressFields.style.display = '';

    try {
      const resp = await fetch('https://viacep.com.br/ws/' + cep + '/json/');
      const data = await resp.json();
      if (data.erro) return;
      const set = (name, val) => { const el = mod._el(name); if (el) el.value = val || ''; };
      set('signup-address', data.logradouro);
      set('signup-neighborhood', data.bairro);
      set('signup-city', data.localidade);
      set('signup-state', data.uf);
      mod._updateSelectPlaceholderStyle(mod._el('signup-state'));
      mod._el('signup-number')?.focus();
    } catch (e) {
      // Falha de rede: deixa preencher manualmente, sem bloquear o formulário.
    }
  },

  // Chamado por onIdentityNew: o e-mail/CPF já foi checado (checkSignup) e
  // confirmado como novo por WsIdentifyFlow — pré-preenche o campo
  // correspondente. O e-mail fica editável (a pessoa pode mudar de ideia no
  // meio do fluxo); só o CPF/CNPJ vem travado, mesma ideia do texto fixo +
  // "Trocar" da etapa de identificação.
  _showSignupScreen(identity) {
    const mod = wsMain.modules['login-sidebar'];
    mod._resetSignupForm();

    if (identity && identity.type === 'email') {
      const emailInp = mod._el('signup-email');
      if (emailInp) emailInp.value = identity.value;
    } else if (identity) {
      const digits = identity.value;
      const isF = digits.length === 11;
      const typeInput = mod._el(isF ? 'signup-type-f' : 'signup-type-j');
      if (typeInput) {
        typeInput.checked = true;
        typeInput.dispatchEvent(new Event('change'));
      }
      const docInp = mod._el(isF ? 'signup-cpf' : 'signup-cnpj');
      if (docInp) {
        docInp.value = isF ? mod._fmtCpf(digits) : mod._fmtCnpj(digits);
        docInp.readOnly = true;
      }
    }

    const screenMain = mod._el('screen-main');
    if (screenMain) screenMain.style.display = 'none';
    const screenSignup = mod._el('screen-signup');
    if (screenSignup) screenSignup.style.display = '';
    // Formulário mais alto que o painel — desliga a centralização vertical
    // do .wslg-scroll pra dar pra rolar até o topo (ver CSS).
    mod._el('scroll')?.classList.add('wslg-scroll--top');
    const headerTitle = mod._el('header-title');
    if (headerTitle) headerTitle.textContent = 'Cadastre-se';
  },

  _resetSignupForm() {
    const mod = wsMain.modules['login-sidebar'];
    const ids = [
      'signup-name', 'signup-lastname', 'signup-razao', 'signup-cpf', 'signup-cnpj',
      'signup-mobile', 'signup-email', 'signup-birth', 'signup-password', 'signup-password-confirm',
      'signup-cep', 'signup-address', 'signup-number', 'signup-complement', 'signup-neighborhood',
      'signup-city', 'signup-state',
    ];
    ids.forEach((name) => {
      const el = mod._el(name);
      if (el) { el.value = ''; el.readOnly = false; }
    });
    const addressFields = mod._el('signup-address-fields');
    if (addressFields) addressFields.style.display = 'none';
    const genderEl = mod._el('signup-gender');
    if (genderEl) genderEl.value = '';
    mod._updateSelectPlaceholderStyle(genderEl);
    mod._updateSelectPlaceholderStyle(mod._el('signup-state'));
    const typeF = mod._el('signup-type-f');
    if (typeF) { typeF.checked = true; typeF.dispatchEvent(new Event('change')); }
    mod._setSignupMsg('', '');
  },

  _setSignupMsg(text, type) {
    const mod = wsMain.modules['login-sidebar'];
    const el = mod._el('signup-msg');
    if (!el) return;
    el.textContent = text || '';
    el.className = 'wscb-msg' + (type ? ' wscb-msg--' + type : '');
  },

  async _submitSignup() {
    const mod = wsMain.modules['login-sidebar'];
    mod._setSignupMsg('', '');

    const val = (name) => (mod._el(name) || {}).value || '';
    const isF = !!(mod._el('signup-type-f') || {}).checked;

    const firstName = val('signup-name').trim();
    const lastName = val('signup-lastname').trim();
    const fullName = (firstName + ' ' + lastName).trim();
    const razao = val('signup-razao').trim();
    const email = val('signup-email').trim();
    const password = val('signup-password');
    const passwordConfirm = val('signup-password-confirm');
    const cpfDigits = mod._onlyDigits(val('signup-cpf'));
    const cnpjDigits = mod._onlyDigits(val('signup-cnpj'));
    const mobileDigits = mod._onlyDigits(val('signup-mobile'));
    const zip = mod._onlyDigits(val('signup-cep'));
    const address = val('signup-address').trim();
    const number = val('signup-number').trim();
    const neighborhood = val('signup-neighborhood').trim();
    const city = val('signup-city').trim();
    const state = val('signup-state').trim().toUpperCase();

    if (!firstName) return mod._setSignupMsg('Informe seu nome.', 'error');
    if (isF) {
      if (cpfDigits.length !== 11) return mod._setSignupMsg('Informe um CPF válido.', 'error');
    } else {
      if (!razao) return mod._setSignupMsg('Informe a razão social.', 'error');
      if (cnpjDigits.length !== 14) return mod._setSignupMsg('Informe um CNPJ válido.', 'error');
    }
    if (!email || !/\S+@\S+\.\S+/.test(email)) return mod._setSignupMsg('Informe um e-mail válido.', 'error');
    if (mobileDigits.length < 10) return mod._setSignupMsg('Informe o celular com DDD.', 'error');
    if (!password || password.length < 6) return mod._setSignupMsg('Crie uma senha de pelo menos 6 caracteres.', 'error');
    if (password !== passwordConfirm) return mod._setSignupMsg('As senhas não coincidem.', 'error');
    if (zip.length !== 8) return mod._setSignupMsg('Informe um CEP válido.', 'error');
    if (!address) return mod._setSignupMsg('Informe o endereço.', 'error');
    if (!number) return mod._setSignupMsg('Informe o número.', 'error');
    if (!neighborhood) return mod._setSignupMsg('Informe o bairro.', 'error');
    if (!city) return mod._setSignupMsg('Informe a cidade.', 'error');
    if (state.length !== 2) return mod._setSignupMsg('Informe o estado (UF) com 2 letras.', 'error');

    // PF: name = nome completo. PJ: name = razão social, contact = nome
    // completo do responsável — mesmo contrato de wsapi3-signup-page.
    const body = {
      name: isF ? fullName : razao,
      email,
      password,
      person_type: isF ? 'F' : 'J',
      cpf_cnpj: isF ? cpfDigits : cnpjDigits,
      newsletter: false,
      mobile: mobileDigits,
      zip_code: zip,
      address,
      address_number: number,
      neighborhood,
      city,
      state,
    };
    if (!isF && fullName) body.contact = fullName;

    const complement = val('signup-complement').trim();
    if (complement) body.complement = complement;
    const genderVal = val('signup-gender');
    if (genderVal) body.gender = genderVal;
    const birthDate = mod._parseBirthDate(val('signup-birth'));
    if (birthDate) body.birth_date = birthDate;

    const btn = mod._el('signup-submit-btn');
    if (btn) { btn.disabled = true; btn.dataset._label = btn.dataset._label || btn.textContent; btn.textContent = 'Aguarde...'; }

    try {
      const data = await ApiWS.Calls.signup(body);
      if (data && data.result === 'success' && data.record) {
        ApiWS.User.saveSession(data.record);
        if (typeof ApiWS !== 'undefined' && ApiWS.CustomerEmail) {
          ApiWS.CustomerEmail.set(
            (data.record.customer && data.record.customer.email) || email,
            { source: 'signup', authoritative: true }
          );
        }
        // Mesmo comportamento de onLoginSuccess: a sidebar abre por cima de
        // qualquer página, então recarrega em vez de redirecionar.
        window.location.reload();
      } else {
        mod._setSignupMsg((data && data.message) || 'Não foi possível concluir seu cadastro. Verifique os dados e tente novamente.', 'error');
      }
    } catch (e) {
      mod._setSignupMsg('Erro de conexão ao criar seu cadastro. Tente novamente.', 'error');
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = btn.dataset._label; }
    }
  },
});
